"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stimulus_1 = require("@hotwired/stimulus");
class default_1 extends stimulus_1.Controller {
    selectLocation(event) {
        event.preventDefault();
        const target = event.target;
        target.dispatchEvent(new Event("location-menu:select", {
            bubbles: true,
        }));
    }
}
exports.default = default_1;
